import type { ApplicationGroup as ApplicationGroupModel } from '@/adapters/catalogv1.g';

export function extractApplicationGroup(model: ApplicationGroupModel) {
  return {
    id: model._metadata?.distinct_id ?? '',
    applicationRef: model.application_ref ?? '',
    groupRef: model.group_ref ?? '',
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogApplicationGroup = ReturnType<
  typeof extractApplicationGroup
>;
